import React, { Component } from 'react';
// import PropTypes from 'prop-types'

class Pane extends Component {
  // eslint-disable-next-line
  propTypes: {
    label: string,
    children: element
  }
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default Pane